module.exports = __webpack_public_path__ + "static/media/tetrapackCorrect.88e150f6.png";